<template>
  <v-card width="281" height="431" outlined color="#E9E5EE" class="sigfloCard">
    <v-row>
      <v-col cols="12" class="text-center mainCol"
        ><v-icon class="mb-2" color="#BCB2CD" large>mdi-plus-circle-outline</v-icon>
        <div class="button1 sigfloButton">Start New Project</div></v-col
      >
    </v-row>
  </v-card>
</template>

<script>
  export default {};
</script>

<style scoped>
  .mainCol {
    padding-top: 170px;
  }
  .button1 {
    color: #bcb2cd;
    font-weight: 400 !important;
  }
</style>
